<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch05">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"><span class="bold">Collaboration with Fly</span></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: -5%; margin-left: 10%;">I put that word on the page,</p>
<p class="extractVerse" style="text-indent: -5%; margin-left: 10%;">but he added the apostrophe.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466806276_ch05.vue?337be5c6